export default "__VITE_ASSET__svOhgMVZLpYhoKkmtcs27Q__"